<template>
  <div class="container" style="margin-top: 20px">
    <SurveyComponent :model="survey" />
  </div>
</template>
<script>
import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import apis from "@/apis";
import surveytemplate from "./survey_template";
import { themeJson } from "./theme";
export default {
  name: "MAHASBMCODEQrSurvey",
  data() {
    return {
      fullPage: true,
      isLoadingModel: false,
      UserID: "",
      StopID: "",
      lat: "",
      lng: "",
      survey: new Model({}),
      stoptyp: [],
      stopsubtyp: [],
      wastetyp: [],
    };
  },
  created() {},
  methods: {},
  async mounted() {
    this.UserID = this.$route.params.UserID;
    this.StopID = this.$route.params.StopID;
    this.lat = this.$route.params.lat;
    this.lng = this.$route.params.lng;
    surveytemplate.pages[0].elements[0].choicesByUrl.url = `https://l8olgbtnbj.execute-api.ap-south-1.amazonaws.com/dev/api/vehicles/surveypanchyatmaster?user_id=${this.UserID}`;
    this.survey = new Model(surveytemplate);
    this.survey.applyTheme(themeJson);
    this.survey.onComplete.add((survey, options) => {
      var surveydata = survey.data;console.log(surveydata);
      
      var data = {
        //group_id: "64cae4661437bcf1e20e8ebe",
        stop_id: this.StopID,
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng),
        user_id: this.UserID,
        stop_type_id: surveydata.Type,
        stop_subtype_id: surveydata.SubType?surveydata.SubType:'',
        commercial_type_id: surveydata.WasteType,
        person_mobile: surveydata.MobileNo,
        person_name: surveydata.Name,
        visit_by:this.UserID,
        panchyat:surveydata.Panchyat
      };
      var promise = apis.Submit_Survey(data);
      promise.then((response) => {
        // this.$swal(response.data.message);
      });
    });
  },
};
</script>
<style scoped></style>